var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"arrow-up",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/img/index/backTop.png"),"alt":""}}),_c('div',[_vm._v("回到顶部")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }